import { Rest } from 'utilities/rest';
import * as ActionCreator from 'utilities/action.creator';
import { $processing, $done } from '../activity/action';

export const MODULE = 'Dashboard';

const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, 'reset', () =>
  $reset.action()
);

export const $get = ActionCreator.Async(MODULE, 'Get', (payload) => {
  return async (dispatch) => {
    dispatch($processing($get.OPERATION));

    return await Rest.GET(`${API_URL}/tms/dashboard`, payload)
      .then((response) => {
        dispatch($get.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($get.OPERATION)));
  };
});

export const $manifest = ActionCreator.Async(MODULE, 'Manifest', (payload) => {
  return async (dispatch) => {
    dispatch($processing($manifest.OPERATION));

    return await Rest.GET(`${API_URL}/tms/manifest/dashboard`, payload)
      .then((response) => {
        dispatch($manifest.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($manifest.OPERATION)));
  };
});

export const $order = ActionCreator.Async(MODULE, 'Order', (payload) => {
  return async (dispatch) => {
    dispatch($processing($order.OPERATION));

    return await Rest.GET(`${API_URL}/tms/delivery/dashboard`, payload)
      .then((response) => {
        dispatch($order.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($order.OPERATION)));
  };
});
